import Vue from 'vue'

const auth = {
  namespaced: true,
  state: {
    auth: {
      token: Vue.prototype.$session.exists('user-token') ? Vue.prototype.$session.get('user-token') : null,
      profile: Vue.prototype.$session.exists('profile') ? Vue.prototype.$session.get('profile') : null
    }
  },
  // CRUD / RESTful actions
  mutations: {
    SET_TOKEN(state, data) {
      Vue.prototype.$session.set('user-token', data)
      Vue.prototype.$axios.defaults.headers.common = {
        "Authorization": "Bearer " + data
      }
      state.auth.token = data
    },
    SET_PROFILE(state, data) {
      Vue.prototype.$session.set('profile', data)
      state.auth.profile = data
    }
  },
  actions: {
    async login(state, user) {
      var tokenCode = user.token.token
      state.commit('SET_TOKEN', tokenCode)
      await Vue.prototype.$axios.get('/profile').then(res => {
        state.commit('SET_PROFILE', res.data)
      })
    },
    async writeToken(state, token) {
      state.commit('SET_TOKEN', token)
    },
    async fetch(state) {
      if(Vue.prototype.$session.exists('user-token')) {
        state.commit('SET_TOKEN', Vue.prototype.$session.get('user-token'))
      }
      if(Vue.prototype.$session.exists('profile')) {
        state.commit('SET_PROFILE', Vue.prototype.$session.get('profile'))
      }
    }
  },
  getters: {
    isAdmin(state) {
      return state.auth.profile.user.isAdmin
    }
  }
}

export default auth